import { Col } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import SmsCode from '@portal/components/SmsCode/SmsCode';
import * as StorageService from '~/services/storage';
import { AuthActions } from '@portal/actions';

import useReduxState from '@portal/hooks/useReduxState';

import Loading from '@portal/components/Loading/Loading';
import { translate } from '@portal/services/i18n';
import {
  getSmsForVinculateCompany,
  getSmsInCoreBanking,
  sendSmsForVinculateCompany,
  sendSmsInCoreBanking,
} from '@portal/actions/user';
import { OperatorStatus } from '@portal/enum/accountStatus';
import { useNavigation } from '@portal/hooks/useNavigation';

const CreateInCoreBank = () => {
  const dispatch = useDispatch();
  const navigate = useNavigation();

  const [disableButton, setDisableButton] = useState(true);
  const [code, setCode] = useState('');

  const {
    user: {
      createInCoreBanking,
      me: { operatorStatus },
    },
    loading: { amount: isLoading },
  } = useReduxState();

  useEffect(() => {
    if (code.length === 6) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [code]);

  const handleResend = () => {
    if (operatorStatus === OperatorStatus.AWAITING_LOGIN) {
      dispatch(getSmsInCoreBanking());
    } else {
      dispatch(getSmsForVinculateCompany());
    }
  };

  useEffect(() => {
    if (operatorStatus === OperatorStatus.AWAITING_LOGIN) {
      dispatch(getSmsInCoreBanking());
    } else {
      setCode('');
      dispatch(getSmsForVinculateCompany());
    }
  }, [operatorStatus, dispatch]);

  useEffect(() => {
    if (createInCoreBanking) {
      navigate('/inicio');
    }
  }, [createInCoreBanking, history]);

  const handleValidateSMS = () => {
    if (operatorStatus === OperatorStatus.AWAITING_LOGIN) {
      dispatch(sendSmsInCoreBanking(code));
    } else {
      dispatch(sendSmsForVinculateCompany(code));
    }
  };

  const handleLogout = () => {
    StorageService.removeItem('session-token');
    dispatch(AuthActions.logout());
    navigate('/');
  };

  return (
    <div className="request-sms">
      <div className="request-sms__form">
        {isLoading > 0 && <Loading />}
        <div className="request-sms__form__icon-lock">
          <img src="assets/svg/lock.svg" alt="" />
        </div>
        <h2 className="request-sms__form__header">
          {operatorStatus === OperatorStatus.AWAITING_LOGIN
            ? translate('PAGES.CONFIRM_USER.TITLE')
            : translate('PAGES.CONFIRM_USER.SECOND_TITLE')}
        </h2>
        <p className="request-sms__form__message">
          {operatorStatus === OperatorStatus.AWAITING_LOGIN
            ? translate('PAGES.CONFIRM_USER.SUBTITLE')
            : translate('PAGES.CONFIRM_USER.SECOND_SUBTITLE')}
        </p>

        <div className="request-sms__form__container">
          <SmsCode
            className="change-credentials__form__inputs--focused"
            code={code}
            setCode={setCode}
            onClickResend={handleResend}
          />
        </div>
        <div className="request-sms__form__inputs">
          <Col className="request-sms__form__button">
            <AdvancedButton
              disabled={disableButton}
              fullWidth
              text={translate('COMPONENTS.ADVANCED_BUTTON.CONFIRM')}
              onClick={handleValidateSMS}
            />
          </Col>

          <Col>
            <AdvancedButton
              variant="outlined"
              fullWidth
              text={translate('COMPONENTS.ADVANCED_BUTTON.CANCEL')}
              onClick={() => {
                setDisableButton(true);
                setCode('');
                handleLogout();
              }}
            />
          </Col>
        </div>
      </div>
    </div>
  );
};

export default CreateInCoreBank;
